var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13258_211118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.72205e-06H21V21H0V5.72205e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13258_211118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57812 19.1543V20.3848",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03906 17.9238L9.26953 19.1543",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11719 17.9238L1.88672 19.1543",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8828 3.07617L19.1133 1.8457",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9609 3.07617L11.7305 1.8457",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.4219H14.1914V16.6523C14.1914 17.3319 14.7423 17.8828 15.4219 17.8828C16.1014 17.8828 16.6523 17.3319 16.6523 16.6523V15.4219H20.3848V11.7305H19.1543C18.4747 11.7305 17.9238 11.1796 17.9238 10.5C17.9238 9.82041 18.4747 9.26953 19.1543 9.26953H20.3848V5.57813H16.6523V6.8086C16.6523 7.48818 16.1014 8.03907 15.4219 8.03907C14.7423 8.03907 14.1914 7.48818 14.1914 6.8086V5.57813H10.5",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34766 15.4219V14.1914C4.34766 13.5118 4.89858 12.9609 5.57812 12.9609C6.25767 12.9609 6.80859 13.5118 6.80859 14.1914V15.4219H10.5V11.7305H11.7305C12.41 11.7305 12.9609 11.1796 12.9609 10.5C12.9609 9.82041 12.41 9.26953 11.7305 9.26953H10.5V5.57813H6.80859V4.34766C6.80859 3.66807 6.25771 3.11719 5.57812 3.11719C4.89854 3.11719 4.34766 3.66807 4.34766 4.34766V5.57813H0.615234V9.26953H1.8457C2.52525 9.26953 3.07617 9.82041 3.07617 10.5C3.07617 11.1796 2.52525 11.7305 1.8457 11.7305H0.615234V15.4219H4.34766Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMatched);
export default __webpack_public_path__ + "static/media/group-matched.8e737eed222ba16fb5fe721eb0d32166.svg";
export { ForwardRef as ReactComponent };